const tracksValidationHR = {
    "trackName": {
        "required": "Naziv pjesme je obavezan",
        "length": "Naziv pjesme mora imati više od 1 i manje od 255 znakova",
        "regexp": "Naziv pjesme može se sastojati samo od slova, brojeva, razmaka i donje crte"
    },
    "mix_name": {
        "required": "Molimo unesite naziv miksa",
        "regexp": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i donje crte"
    },
    "artistName": {
        "required": "Molimo odaberite izvođača"
    },
    "artistType": {
        "required": "Molimo odaberite tip izvođača"
    },
    "atleastOneMainArtist": {
        "required": "Najmanje jedan izvođač mora biti glavni"
    },
    "duplicateArtists": {
        "required": "Postoje dva ili više izvođača s istim imenom."
    },
    "publisherName": {
        "required": "Molimo odaberite izdavača"
    },
    "publisherAuthor": {
        "required": "Molimo unesite pravo ime i prezime osobe."
    },
    "contributorName": {
        "required": "Molimo odaberite suradnika"
    },
    "contributorRole": {
        "required": "Molimo odaberite ulogu suradnika"
    },
    "atleastOneComposer": {
        "required": "Najmanje jedan suradnik treba biti skladatelj"
    },
    "atleastOneLyricist": {
        "required": "Najmanje jedan suradnik treba biti tekstopisac"
    },
    "copyright": {
        "required": "Autorsko pravo je obavezno",
        "regexp": "Autorsko pravo može se sastojati samo od slova, brojeva, razmaka i donje crte"
    },
    "copyrightYear": {
        "required": "Godina autorskog prava je obavezna",
        "regexp": "Godina autorskog prava mora biti valjana godina"
    },
    "ISRC": {
        "required": "Molimo navedite ISRC ili označite Generiraj ISRC",
        "regexp": "Molimo unesite valjani ISRC kod ili ostavite prazno"
    },
    "DA_ISRC": {
        "required": "Molimo navedite Dolby Atmos ISRC ili označite Generiraj ISRC",
        "regexp": "Molimo unesite valjani ISRC kod ili ostavite prazno"
    },
    "trackLanguage": {
        "required": "Jezik pjesme je obavezan. Molimo odaberite jezik vašeg naziva pjesme."
    },
    "trackVocals": {
        "required": "Vokal pjesme je obavezan. Molimo odaberite jezik vaših vokala."
    },
    "trackGenre": {
        "required": "Molimo odaberite žanr vaše pjesme."
    },
    "trackSubGenre": {
        "required": "Molimo odaberite podžanr vaše pjesme"
    },
    "featuringArtistMissing": {
        "required": "Pjesma mora imati istaknutog izvođača navedenog u naslovu ispravno dodijeljenog kao istaknuti izvođač. Molimo ispravite i ponovno pošaljite."
    }
};

export default tracksValidationHR;